<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="礼物名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入礼物名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否启用" prop="isEnabled">
                <a-select v-model="queryParam.isEnabled" placeholder="请选择是否启用">
                  <a-select-option value="0">
                    禁用
                  </a-select-option>
                  <a-select-option value="1">
                    启用
                  </a-select-option>

                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="花费金豆数" prop="goldenBeans">-->
<!--                <a-input v-model="queryParam.goldenBeans" placeholder="请输入花费金豆数" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="图片地址" prop="imgUrl">-->
<!--                  <a-input v-model="queryParam.imgUrl" placeholder="请输入图片地址" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="特效地址" prop="giftEffects">-->
<!--                  <a-input v-model="queryParam.giftEffects" placeholder="请输入特效地址" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="排序, asc" prop="sort">-->
<!--                  <a-input v-model="queryParam.sort" placeholder="请输入排序, asc" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['gift:gift:add']">
          <a-icon type="plus" />新增
        </a-button>
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['gift:gift:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->

        <a-button type="primary" @click="handleSaveSort" v-hasPermi="['gift:gift:add']">
          保存排序
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['gift:gift:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['gift:gift:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
<!--        <table-setting-->
<!--          :style="{float: 'right'}"-->
<!--          :table-size.sync="tableSize"-->
<!--          v-model="columns"-->
<!--          :refresh-loading="loading"-->
<!--          @refresh="getList" />-->
      </div>
      <!-- 增加修改 -->
      <createModalForm
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <img style="width: 55px;height: 55px;" v-image-preview :src="record.imgUrl" slot="imgUrl" slot-scope="text, record">
        <a :href="record.giftEffects" target="_blank" slot="giftEffects" slot-scope="text, record">{{record.giftEffects}}</a>
        <a-switch slot="isEnabled" slot-scope="text, record" @click="updateGoodsState(record)" v-model="record.isEnabled == 1">
          <a-icon type="check" slot="checkedChildren"/>
          <a-icon type="close" slot="unCheckedChildren"/>
        </a-switch>
        <input slot="sort" slot-scope="text, record" :value="text" style="width: 100%;text-align: center;"
               class="ant-input" @change="onCellChange(record.id, $event)"/>
        <span slot="operation" slot-scope="text, record">
<!--          <a-divider type="vertical" v-hasPermi="['gift:gift:edit']" />-->
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['gift:gift:edit']">
<!--            <a-icon type="edit" />-->
            编辑
          </a>
          <a-divider type="vertical" v-hasPermi="['gift:gift:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['gift:gift:remove']">
<!--            <a-icon type="delete" />-->
            删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageGift, listGift, delGift, updateGift, editEnable,saveSort} from '@/api/gift/gift'
// import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import createModalForm from './modules/CreateModalForm'

export default {
  name: 'Gift',
  components: {
    // CreateForm
    createModalForm

  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        goldenBeans: null,
        imgUrl: null,
        giftEffects: null,
        sort: null,
        isEnabled: null,
        pageNum: 1,
        pageSize: 10
      },
      changeSort: [],
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          align: 'center',
          width: 60,
          customRender: function (text, record, index) {
            return (index + 1)
          }
        },


        {
          title: '礼物名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '花费金豆数',
          dataIndex: 'goldenBeans',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '图片地址',
          dataIndex: 'imgUrl',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'imgUrl' }
        },
        {
          title: '特效地址',
          dataIndex: 'giftEffects',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'giftEffects' }

        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'sort' }
        },
        {
          title: '是否启用',
          dataIndex: 'isEnabled',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'isEnabled' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /**
     * 修改哪个排序
     * @param id
     * @param e
     */
    onCellChange(id,e) {
      var sort=e.target.value;
      var changeSort=this.changeSort;
      var flag=true;
      changeSort.forEach((value) => {
        if(value['id']==id){
          flag=false;
          value['sort']=sort;
          return true;
        }
      });
      if(flag){
        changeSort.push({id:id,sort:sort});
      }
    },
    handleSaveSort() {
      const that = this;
      var arr=this.changeSort;
      if(arr.length<1){
        that.$message.warning("暂无数据");
        return;
      }
      saveSort(arr).then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          this.getList();
        } else {
          that.$message.warning(res.message);
        }
      });
    },
    /**
     * 启用/禁用
     */
    updateGoodsState(record) {
      console.log(record)
      let editRecordData = {
        id:record.id,
        isEnabled:record.isEnabled ? false : true
      }
      editEnable(editRecordData).then(response => {
        // this.$message.success(
        //   '修改成功',
        //   3
        // )
        // this.open = false
        if(response.code == 20001) {
          record.isEnabled = record.isEnabled ? false : true
        } else {
        }
        // this.$emit('ok')
      }).finally(() => {
        // this.submitLoading = false
      })
    },
    /** 查询礼物列表 */
    getList () {
      this.loading = true
     pageGift(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        goldenBeans: undefined,
        imgUrl: undefined,
        giftEffects: undefined,
        sort: undefined,
        isEnabled: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delGift(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('gift/gift/export', {
            ...that.queryParam
          }, `礼物_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
